import { useContext } from 'react';
import { GlobalActionsContext } from '../contexts/GlobalActionsContext/GlobalActionsContext.esm.js';

var useGlobalActions = function () {
    var actionsMap = useContext(GlobalActionsContext).actionsMap;
    var dispatchAction = function (actionName, props) {
        var action = actionsMap[actionName];
        if (!action) {
            console.warn("Action \"".concat(String(actionName), "\" was not found"));
            return;
        }
        action(props);
    };
    return {
        dispatchAction: dispatchAction,
    };
};

export { useGlobalActions };
//# sourceMappingURL=useGlobalActions.esm.js.map
